// extracted by mini-css-extract-plugin
export default {"strikeThrough":"TimeRangeSection_strikeThrough__aX3xB","text":"TimeRangeSection_text__JkbPx"};